import CustomLayout from "./wrapPageElement"
require('./node_modules/rc-drawer/assets/index.css')

export const wrapPageElement = CustomLayout
